<template>
  <paper-simple class="card">
    <div class="d-flex justify-content-end">
      <a
        v-if="showArrow"
        :class="visible ? null : 'collapsed'"
        :aria-expanded="visible ? 'true' : 'false'"
        aria-controls="collapse-1"
        size="sm"
        @click="visible = !visible"
      >
        <GjIcon
          class="arrow"
          :class="visible ? 'active' : ''"
          name="ArrowDown"
        />
      </a>
      <slot name="options" />
    </div>
    <div class="d-flex flex-wrap">
      <template v-for="field in fields">
        <input-field
          v-if="field.isPrimary"
          :key="field.key || field"
          :label="field.label || titleCase(field.key) || titleCase(field)"
          :name="field.key || field"
          label-position="top"
          class="text-break"
          :class="`col-${colNumber}`"
        >
          <slot :name="field.key || field">
            {{ item[field.key || field] || '-' }}
          </slot>
        </input-field>
      </template>
    </div>
    <b-collapse
      id="collapse-1"
      v-model="visible"
    >
      <div class="d-flex flex-wrap">
        <template v-for="field in fields">
          <input-field
            v-if="!field.hide && !field.isPrimary"
            :key="field.key || field"
            :label="field.label || titleCase(field.key) || titleCase(field)"
            :name="field.key || field"
            label-position="top"
            class="col-6 text-break"
          >
            <slot :name="field.key || field">
              {{ item[field.key || field] || '-' }}
            </slot>
          </input-field>
        </template>
      </div>
      <slot />
    </b-collapse>
  </paper-simple>
</template>
<script>
export default {
  name: 'Card',
  props: {
    fields: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    colNumber: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$emit('opened')
      }
    },
  },
  methods: {
    titleCase(str) {
      if (str) {
        const result = str.replace(/([A-Z])/g, ' $1')
        const finalResult = result.charAt(0).toUpperCase() + result.slice(1)
        return finalResult
      }
      return str
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  margin-bottom: 1rem;
  ::v-deep {
    .card-body {
      padding: 0.8rem;
      span.text-danger {
        display: none;
      }
      .labelMargin {
        margin-bottom: 5px;
      }
    }
    .btn.dropdown-toggle {
      height: auto;
      &::after {
        display: none;
      }
    }
  }
  .arrow {
    transform: rotate(0);
    transition: 0.4s ease;
    &.active {
      transform: rotate(180deg);
      transition: 0.4s ease;
    }
  }
}
</style>
